import React, { memo, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
// import { Helmet } from "react-helmet";
import { Helmet } from 'react-helmet-async';
import ReactGA from 'react-ga4';
import useSearch from '../../../hooks/useSearch';
import { ATIVO_MERCADO, ATIVO_TIPO } from '@investirapri/financa.js/lib/enums';
import { SETORES } from '../../../enums';

const Head = memo(props => {
  const location = useLocation();
  const isProduction = process.env.NODE_ENV === 'production';
  const search = useSearch();

  function getPageTitle(pTitle, pLocation) {
    let xTitle = pTitle;

    if (search?.mercado) {
      const xMercado = search.mercado;
      xTitle = `${xTitle} - ${ATIVO_MERCADO[xMercado].descricao}`;
    }

    if (search?.ativo_tipo_id) {
      const xAtivoTipo = search.ativo_tipo_id;
      xTitle = `${xTitle} - ${ATIVO_TIPO[xAtivoTipo].sigla}`;
    }

    if (search?.top_setor_id) {
      const xSetor = search.top_setor_id;
      xTitle = `${xTitle} - ${SETORES[xSetor].setor}`;
    }

    if (pLocation?.pathname && pLocation.pathname.includes('/page/')) {
      const xPagina = pLocation.pathname.split('/page/')[1];
      xTitle = `${xTitle} - Página ${xPagina}`;
    }

    return xTitle;
  }

  useEffect(() => {
    isProduction &&
      ReactGA.send({
        hitType: 'pageView',
        page: location.pathname + location.search,
        title: props.title
      });
  }, [location, props.title]);

  const xPageTitle = `${getPageTitle(props.title, location)} | Investira.biz`;

  return (
    <Helmet>
      <title>{xPageTitle}</title>
      <meta name="description" content={props.description} />
      {/* <link rel="canonical" href={window.location.toString()} /> */}
      <meta property="og:locale" content="pt_BR" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={xPageTitle} />
      <meta property="og:description" content={props.description} />
      <meta property="og:url" content={window.location.toString()} />
      <meta property="og:site_name" content="Investira.biz" />
      <meta property="og:image" content="https://static.investira.com.br/Investira_Icone_500.jpg" />
      {props.children}
    </Helmet>
  );
});

Head.displayName = 'Head';

export default Head;
